// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W5qB1","toggleWrap":"styles_toggleWrap__gD5FA","content":"styles_content__tD9l0","selectAreaCode":"styles_selectAreaCode__s1--E"};